import gql from 'graphql-tag'

export const newCertificateOfInsurance = gql`
  mutation($input: CertificateOfInsuranceInput!) {
    newCertificateOfInsurance(
      input: $input
    ) {
      id
    }
  }
`

export const editCertificateOfInsurance = gql`
  mutation($coiId: Int!, $input: CertificateOfInsuranceInput!) {
    editCertificateOfInsurance(
      coiId: $coiId,
      input: $input
    ) {
      id
    }
  }
`

export const deleteCertificateOfInsurance = gql`
  mutation($coiId: Int!) {
    deleteCertificateOfInsurance(
      coiId: $coiId
    )
  }
`

export const getCertificateOfInsurance = gql`
  query($coiId: Int!) {
    getCertificateOfInsurance(
      coiId: $coiId
    ) {
      id
      coi
      revisionNumber
      account {
        id
        name
        mailingAddressCity
        mailingAddressPostalCode
        mailingAddressStreet
        mailingAddressState
        phone
        otherPhone
      }
      policies {
        generalLiabilityPolicy {
          id
          policyName
          effectiveDate
          expirationDate
          policyNumber
          carrier {
            name
          }
        }
        automobilePolicy {
          id
          policyName
          effectiveDate
          expirationDate
          policyNumber
          carrier {
            name
          }
        }
        umbrellaExcessLiabilityPolicy {
          id
          policyName
          effectiveDate
          expirationDate
          policyNumber
          carrier {
            name
          }
        }
        workersCompensationPolicy {
          id
          policyName
          effectiveDate
          expirationDate
          policyNumber
          carrier {
            name
          }
        }
        otherPolicy {
          id
          policyName
          effectiveDate
          expirationDate
          policyNumber
          carrier {
            name
          }
        }
      }
      acordForms {
        id
        notes
        name
        size
        version
        url
        lockedUrl
        createdAt
        acordFormId
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      createdAt
      updatedAt
    }
  }
`
